import { pcrHasData } from "../../utils/pcr.helper";
import { tinkHasData } from "../../utils/tink.helper";
import { PcrSection } from "./sections/PcrSection";
import { TinkSection } from "./sections/TinkSection";
import type { ExternalDataSource } from "./types";

// Registry of external data sources shown in the "External data" tab.
//
// To add a new source:
//   1. Create a self-contained section component under `sections/`.
//   2. Export an `isAvailable`-style helper that reports whether the case has
//      that source's data.
//   3. Add an entry here. The tab shell and the tab config need no changes.
export const externalDataSources: ExternalDataSource[] = [
  {
    id: "tink",
    title: "Tink Data",
    isAvailable: (data) => tinkHasData(data),
    Component: TinkSection
  },
  {
    id: "pcr",
    title: "PCR Data",
    isAvailable: (data) => pcrHasData(data),
    Component: PcrSection
  }
];
